module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "popup-container container-fluid desktop"
  }, [_c('div', {
    staticClass: "popup-close",
    class: {
      'active': true
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('div', {
    staticClass: "burger-bar close-bar-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "burger-bar close-bar-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row  popup-copy-container "
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('img', {
    staticClass: "popup-logo-image",
    attrs: {
      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_logo
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "popup-title-image",
    attrs: {
      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_title
    }
  }), _vm._v(" "), _vm._l((_vm.takeaway_popup.body), function(p, index) {
    return _c('p', {
      staticClass: "page-paragraph page-paragraph-small",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), (_vm.takeaway_popup.popup_button_active) ? _c('div', {
    staticClass: "router-link-container",
    attrs: {
      "to": _vm.takeaway_popup.popup_link
    },
    on: {
      "click": _vm.clickLink
    }
  }, [_c('link-button', {
    attrs: {
      "label": _vm.takeaway_popup.popup_button
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('img', {
    attrs: {
      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_main_desktop
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-container container mobile"
  }, [_c('div', {
    staticClass: "popup-close",
    class: {
      'active': true
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('div', {
    staticClass: "burger-bar close-bar-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "burger-bar close-bar-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('img', {
    staticClass: "popup-logo-image",
    attrs: {
      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_logo
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "popup-title-image",
    attrs: {
      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_title
    }
  }), _vm._v(" "), _vm._l((_vm.takeaway_popup.body), function(p, index) {
    return _c('p', {
      staticClass: "page-paragraph page-paragraph-small",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), (_vm.takeaway_popup.popup_button_active) ? _c('div', {
    staticClass: "router-link-container",
    attrs: {
      "to": _vm.takeaway_popup.popup_link
    },
    on: {
      "click": _vm.clickLink
    }
  }, [_c('link-button', {
    attrs: {
      "label": _vm.takeaway_popup.popup_button
    },
    on: {
      "click": _vm.closePopup
    }
  })], 1) : _vm._e()], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fc2cd09","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TakeawayPopup.vue
// module id = 153
// module chunks = 2